import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';

import styles from '../../styles/styles.css';

import { BannerLink as Component } from './banner-link';
import type { IDeps, TBannerLink } from './models';

export const BannerLink = createWidget<IDeps, TBannerLink>({
    Link,
    styles,
})(Component);
